const state = {
  snackbar: {
    status: false,
    color: "red",
    bg: "white",
  },
  snackMessage: "",
  
};

const getters = {
  snackbar: (state) => state.snackbar,
  snackMessage: (state) => state.snackMessage,
};

const mutations = {
  /**
   * @snackbar
   */
  SET_SNACKBAR(state, data) {
    state.snackbar = data;
  },
  SET_SNACK_MESSAGE(state, data) {
    state.snackMessage = data;
  },
};

const actions = {
  /**
   * @snackbar
   */
  setSnackMessage({ commit }, schema) {
    commit("SET_SNACKBAR", schema.snackbar);
    commit("SET_SNACK_MESSAGE", schema.message);
    // Auto-fermeture du snackbar après 4 secondes
    setTimeout(() => {
      commit("SET_SNACKBAR", { status: false, color: 'red', bg: 'white' });
      commit("SET_SNACK_MESSAGE", '');
    }, 4000);
  },
};

export default {
  state,
  getters,
  mutations,
  actions,
};
